import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Meme from './components/meme';

export default function App() {
  return(
    <div>
      <Navbar />
      <Meme />

    </div>
  )
}